import mixpanel from 'mixpanel-browser';
import { ENV } from '@config/env';

const MIXPANEL_TOKEN = ENV.mixpanelToken;

// When true, no events are sent to Mixpanel (excludeFromAnalytics users).
let _blocked = false;

export const setAnalyticsBlocked = blocked => {
  _blocked = Boolean(blocked);
  if (!MIXPANEL_TOKEN) {
    return;
  }
  if (_blocked) {
    // opt_out_tracking stops ALL data collection: events, identity, AND heatmap/session recording.
    mixpanel.opt_out_tracking();
  } else {
    // Re-enable tracking for the next (non-excluded) user session.
    mixpanel.opt_in_tracking();
  }
};

export const initMixpanel = () => {
  if (!MIXPANEL_TOKEN) {
    console.warn('Mixpanel token missing');
    return;
  }

  mixpanel.init(MIXPANEL_TOKEN, {
    debug: ENV.isDebug,
    track_pageview: false,
    persistence: 'localStorage',
    record_sessions_percent: 100,
    record_heatmap_data: true,
  });
};

export const trackEvent = (event, properties = {}, options) => {
  if (!MIXPANEL_TOKEN || _blocked) {
    return;
  }
  // `options.transport: 'sendBeacon'` — pass this for any event fired right
  // before a hard navigation (window.location.replace/assign). The default
  // XHR transport is async and gets cancelled mid-flight when the page
  // unloads before it completes, so the event never reaches Mixpanel even
  // though trackEvent was called; sendBeacon is queued by the browser and
  // survives the unload.
  mixpanel.track(event, properties, options);
};

export const setTrackingContext = (properties = {}) => {
  if (!MIXPANEL_TOKEN || _blocked) {
    return;
  }
  const toSet = {};
  for (const [key, value] of Object.entries(properties)) {
    if (value === null || value === undefined) {
      mixpanel.unregister(key);
    } else {
      toSet[key] = value;
    }
  }
  if (Object.keys(toSet).length > 0) {
    mixpanel.register(toSet);
  }
};

export const identifyUser = (userId, properties = {}) => {
  if (!MIXPANEL_TOKEN || _blocked) {
    return;
  }
  mixpanel.identify(String(userId));
  mixpanel.people.set(properties);
};

export const resetAnalyticsUser = () => {
  if (!MIXPANEL_TOKEN) {
    return;
  }
  mixpanel.reset();
};
